<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>Processor设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div style="margin-bottom: 20px">
        <el-autocomplete
          class="inline-input"
          v-model="pagination.code"
          :fetch-suggestions="querySearch"
          placeholder="请输入币种"
        >
          <i
            class="el-icon-close el-input__icon"
            slot="suffix"
            @click="cleanSearchCoin"
            style="cursor: pointer"
          >
          </i>
        </el-autocomplete>
        <el-button type="primary" class="btn" @click="queryList"
          >搜索</el-button
        >
      </div>
      <processor-list @refresh="refreshList"></processor-list>
      <!-- <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="refreshList"
      >
      </pagination> -->
      <el-pagination
        @current-change="queryList"
        :current-page="pagination.page"
        :page-size="pagination.size"
        :page-sizes="[5, 10, 15, 20]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import "./store";
import api from "./api";
import { mapActions, mapState } from "vuex";
import ProcessorList from "./components/list";
import Pagination from "components/pagination";

export default {
  name: "ProcessorConfig",
  components: {
    ProcessorList,
    Pagination,
  },
  data() {
    return {
      coinTypes: [],
      code: "",
      pagination: {
        page: 1,
        size: 5,
      },
    };
  },
  computed: {
    ...mapState("processorConfigSetting", ["totalCount", "coinType"]),
  },
  methods: {
    ...mapActions("processorConfigSetting", ["list"]),
    queryList(val) {
      if (Number.isFinite(val)) {
        this.pagination.page = val
      }
      this.list({
        code: this.code,
        ...this.pagination,
      });
    },
    refreshList() {
      this.list({
        code: this.coinType,
      });
    },
    getAllSupportCoin() {
      api.getAllSupportCoin().then(({ data }) => {
        this.coinTypes = data;
      });
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.coinTypes;
      results = queryString
        ? coinList.filter(this.createFilter(queryString))
        : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v,
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.coinTypes;
      return (tempData) => {
        return tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    cleanSearchCoin() {
      this.pagination.code = "";
    },
  },
  created() {
    this.list(this.pagination);
    this.getAllSupportCoin();
  },
};
</script>

<style lang="less" scoped>
.btn {
  margin-left: 20px;
}
.el-pagination {
  text-align: right;
}
</style>
